<!-- Use preprocessors via the lang attribute! e.g. <template lang="pug"> -->
4

<!-- >https://cdn.vuetifyjs.com/images/parallax/material2.jpg -->
<template>
  <div class="">
    <v-parallax class="mb-3 profile" dark>
      <v-row>
        <v-col cols="12" align="center" justify="center">
          <v-img
            height="100"
            width="100"
            :src="profile.fotoUrl"
            class="rounded-circle text-center mt-5"
          ></v-img>
          <v-card-title
            class="justify-center font-weight-bold text-xs-body-2 warnaText"
          >
            <p class="textBaru">
              {{ getInfo.fullname }} - {{ profile.company }}
            </p></v-card-title
          >
          <!-- <div class="body-2" v-if="profile.positionTitle != null">
            {{ profile.company }}
          </div> -->
          <!-- <div class="body-2">
            {{ profile.company }}
          </div> -->
        </v-col>
      </v-row>
    </v-parallax>

    <div class="d-flex flex-column justify-space-between mx-4">
      <v-row align="center" justify="center">
        <!-- <v-col v-if="disabledRoom" class="col-12">
            <v-card
              class="mx-auto rounded-lg lighten-1 light-blue accent-3"
              outlined
              @click="getSeatNumber"
            >
              <v-card-text
                class="text-xs-caption text-md-h6 font-weight-bold white--text"
              >
                Get Room
              </v-card-text>
            </v-card>
          </v-col> -->
        <!-- <v-col>
              <v-card
                class="mx-auto rounded-lg lighten-1 indigo accent-2"
                outlined
                @click="getGiftNumber"
                :disabled="disabled"
              >
                <v-card-text
                  class="text-xs-caption text-md-h6 font-weight-bold white--text"
                >
                  Get Gift Number
                </v-card-text>
              </v-card>
            </v-col> -->

        <v-row class="px-4 pt-5">
          <v-col>
            <v-card class="mx-auto rounded-lg" height="170" elevation="0">
              <p class="px-3 pt-3 text-caption text-sm-h6">My Gift Number</p>
              <v-card-text class="text-h2 font-weight-bold light-blue--text">
                {{ profile.noKado }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="mx-auto rounded-lg" height="170" elevation="0">
              <p class="px-3 pt-3 text-caption text-sm-h6">Gift Number I Get</p>
              <v-card-text v-if="loading">
                <v-overlay>
                  <v-progress-circular
                    :size="70"
                    :width="10"
                    color="amber"
                    indeterminate
                  ></v-progress-circular>
                </v-overlay>
              </v-card-text>
              <v-card-text class="text-h2 font-weight-bold indigo--text" v-else
                >{{ dataEvent.getKado ? dataEvent.getKado : "?" }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!-- <v-col cols="12" align-self="start" class="pb-1">
          <v-card class="mx-auto my-2 elevation-0 px-5 py-5 text-left">
            <h4 class="text-h6">Greetings {{ profile.nama }}</h4>
            <div v-html="kataPengantar"></div>
          </v-card>
        </v-col> -->

        <v-col class="col-12 coba">
          <v-card
            class="mx-auto rounded-lg magenta lighten-3"
            outlined
            @click="goToAbout"
          >
            <v-card-text
              class="text-xs-caption text-md-h6 font-weight-bold white--text"
            >
              About Event
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-if="setStatusMvp" class="col-12 pt-0 pb-16">
          <v-card
            class="mx-auto rounded-lg btnPrimary lighten-2"
            outlined
            @click="goToMvp"
          >
            <v-card-text
              class="text-xs-caption text-md-h6 font-weight-bold white--text"
            >
              Vote MVP Employee
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    disabledRoom: true,
    loadingRoom: false,
    disabled: false,
    loading: false,
    giftNumber: "19",
    getNumber: "?",
    roomSeat: "",
    profile: {
      digits: "",
      fotoUrl: "",
      workType: "",
      // positionTitle: "",
      company: "",
      noKado: null,
    },
    dataEvent: {
      noKado: null,
      getKado: null,
      Id: 32,
      roomName: false,
    },
    kataPengantar: `<p><strong><i>"Future-proof Mentality"</i></strong> is the theme of our journey in ${new Date().getFullYear()}.</p> <p>At this moment, we will celebrate our milestones, achievements, and endeavor through Covid-19 pandemic.</p> <p> We know that along the year we have encountered obstacles, challenges, and hardships as well. Nevertheless, built upon our spirit at the beginning of the year, "L.E.T.S (Learn, Embrace, Think, Solve) Grow!", we have to believe that together <strong>WE CAN GROW TOGETHER!</strong></p>`,
    setStatusMvp: false,
  }),
  mounted() {
    this.profile = this.getInfo;
  },
  beforeMount() {
    this.fetchStatus();
    this.statusMvp();
  },
  computed: {
    getInfo() {
      return this.$store.getters.userInfo;
    },
    getFeedback() {
      return this.$store.getters.userFeedback;
    },
  },
  methods: {
    fetchStatus() {
      this.axios
        .get(
          `${process.env.VUE_APP_API}/api/users/status/` + this.getInfo.digits
        )
        .then((response) => {
          const payload = response.data.data;

          this.buttonDisabled1 = payload.dosurvey;
          this.dataEvent.getKado = payload.getKado;
          // console.log(payload, "<< CEHCK RESP");
        })
        .catch((error) => {
          if (error.response) {
            const payload = error.response.data;
            // const obj = JSON.parse(payload)
            this.pesan = payload.message;
            this.alert = true;
          } else {
            const payload = error.message;
            // const obj = JSON.parse(payload)
            this.pesan = payload;
            this.alert = true;
          }
          // console.log(payload.message);
        });
    },
    statusMvp() {
      this.axios
        .get(`${process.env.VUE_APP_API}/api/properties`)
        .then((response) => {
          const payload = response.data;
          // console.log(payload, "<< CHECK PAYLOAD");
          this.setStatusMvp = payload.data.isavailable;
        })
        .catch((error) => {
          if (error.response) {
            const payload = error.response.data;
            // const obj = JSON.parse(payload)
            this.pesan = payload.message;
            this.alert = true;
          } else {
            const payload = error.message;
            // const obj = JSON.parse(payload)
            this.pesan = payload;
            this.alert = true;
          }
          // console.log(payload.message);
        });
    },
    getSeatNumber() {
      this.$router.push({ name: "map" });
      this.axios
        .get(`${process.env.VUE_APP_API}/api/events`)
        .then((response) => {
          const payload = response.data;

          this.disabledRoom = false;
        });
    },
    goToMvp() {
      this.$router.push({ name: "performance" });
    },
    goToAbout() {
      this.$router.push({ name: "about" });
    },
    reserve() {
      this.loading = true;

      setTimeout(() => (this.loading = false), 2000);
    },
  },
};
</script>
<style scoped>
.profile {
  background-image: url("../../assets/banner2025rev4.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 210px !important;
  margin-bottom: 5% !important;
  background-color: #32313f !important;
}

@media (min-width: 1024px) {
  .profile {
    background-image: url("../../assets/banner2025.png");
  }
}

.coba {
  padding-top: 20%;
}
.magenta {
  background-color: rgb(114, 64, 31);
}
.warnaText {
  margin-top: 45px;
  background-color: rgb(114, 64, 31);
  /* opacity: 0.8; */
  width: 350px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}
.textBaru {
  color: white;
  margin-top: -15px;
}
</style>
